<template>
  <div>
    <page-header slot="header" @submit="handleSubmit" ref="header" />
    <page-main
      ref="main"
      :table-data="table"
      :params="params"
      :loading="loading"
      @submit="handleSubmit"
    />
    <p></p>
    <js-pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        align="left"
        @change="handlePaginationChange"
    />
  </div>
</template>

<script>
// import { getList } from '@api/baseUser'
export default {
  components: {
    'PageHeader': () => import('./components/header/index'),
    'PageMain': () => import('./components/main/index')
    // 'PageFooter': () => import('@/components/pagination')
  },
  props: {
    params: {
      default: null,
      type: Object
    },
    disabled: {
      default: true,
      type: Boolean
    },
    autoLoad: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    params: {
      handler () {
        if (this.autoLoad) {
          this.handleSubmit()
        }
      },
      deep: true
    }
  },
  data () {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      }
    }
  },
  methods: {
    load () {
      this.handleSubmit()
    },
    // 分页查询
    handlePaginationChange (val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 加载表格数据
    handleSubmit (params) {
      this.loading = true
      this.$api.baseUserListApi({
        ...params,
        ...this.params,
        ...this.page
      }).then(res => {
        this.loading = false
        this.page.pageTotal = res.body.count
        this.table = res.body.data
      }).catch(() => {
        this.loading = false
      })
    }
  },
  computed: {
    selected () {
      return this.$refs.main.multipleSelection
    }
  }
}
</script>
